// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6452":"4c7f5789","6850":"d5cd9b9b","6942":"4d7e2bf4"}[chunkId] + ".chunk.css";
};